// extracted by mini-css-extract-plugin
export default {"mainSection":"PageBackground_mainSection__TsVN1"};